import React, { useEffect, useState } from "react";
import { imgBaseUrl } from "../../api/api";
import "./StudentCharacterCertificate1.css";

export default function StudentCharacterCertificate1({ data }) {
  const [setting, setSetting] = useState({});

  useEffect(() => {
    setSetting(JSON.parse(localStorage.getItem("setting") ?? "{}"));
  }, []);

  const logoUrl = imgBaseUrl + setting?.logo_img;

  return (
    <div
      className="cc-outer"
      id="PrintDiv"
      style={{ "--cc-logo-url": `url(${logoUrl})` }}
    >
      <div className="cc-inner">
        <div className="cc-corner cc-corner-tl" />
        <div className="cc-corner cc-corner-tr" />
        <div className="cc-corner cc-corner-bl" />
        <div className="cc-corner cc-corner-br" />

        <div className="cc-header">
          <div className="cc-logo-box">
            <img src={logoUrl} alt="logo" />
          </div>

          <div className="cc-header-text">
            <h1 className="cc-inst-name">{setting?.name}</h1>
            <p className="cc-inst-meta">
              {setting?.village}, {setting?.district}, {setting?.state} -{" "}
              {setting?.pin_code}
            </p>
            <p className="cc-inst-meta">
              Mobile: {setting?.mobile}
              {setting?.secondary_mobile &&
                `, ${setting?.secondary_mobile}`} • {setting?.email}
            </p>
          </div>

          <div className="cc-header-placeholder"></div>
        </div>

        <div className="cc-title-block">
          <p className="cc-eyebrow">This certifies that</p>
          <h2 className="cc-title">Character Certificate</h2>
          <div className="cc-title-rule">
            <span className="line" />
            <span className="dot" />
            <span className="line" />
          </div>
        </div>

        <div className="cc-meta-row">
          <div>
            Certificate No: <span>{data?.certificate_no ?? "—"}</span>
          </div>
          <div>
            Date of Issue:{" "}
            <span>{data?.issue_date ?? new Date().toLocaleDateString()}</span>
          </div>
        </div>

        <div className="cc-body">
          <p>
            This is to certify that Mr./Ms. <b>{data?.student_info?.name}</b>{" "}
            S/o / D/o <b>{data?.student_info?.father_name}</b> was a bonafide
            student of <b>{setting?.name}</b>, bearing Registration No.{" "}
            <b>{data?.student_info?.registration_no}</b>.
          </p>
          <p>
            He/She studied in <b>{data?.batch?.course?.title}</b> course during
            the academic session <b>{data?.batch?.session ?? "—"}</b>.
          </p>
          <p>
            During his/her stay in the institute, his/her conduct and character
            were found to be <b>GOOD</b>. We wish him/her success and a bright
            future ahead.
          </p>
        </div>

        <div className="cc-footer">
          <div className="cc-footer-col">
            <div>Place: {setting?.village}</div>
          </div>
          <div className="cc-footer-col">
            <div className="cc-line">Principal Seal & Signature</div>
          </div>
        </div>
      </div>
    </div>
  );
}
